import forEach from 'lodash/forEach';

import {
  MESSAGE_TREE_TYPE_ALTERNATE,
  MESSAGE_TREE_TYPE_BRANCH,
  MESSAGE_TREE_TYPE_COMMENT,
  MESSAGE_TREE_TYPE_CONTEXTUAL,
  MESSAGE_TREE_TYPE_LINK_TO_MQA
} from '../constants';

export default function sortGpfTree(tree) {
  const sortedTree = tree.slice().sort((a, b) => a.SortOrder - b.SortOrder);
  const filteredTree = [];
  let temporaryArray = [];
  forEach(sortedTree, (sortedTreeItem, index) => {
    if (
      sortedTreeItem.Type === MESSAGE_TREE_TYPE_COMMENT ||
      sortedTreeItem.Type === MESSAGE_TREE_TYPE_ALTERNATE ||
      sortedTreeItem.Type === MESSAGE_TREE_TYPE_CONTEXTUAL ||
      sortedTreeItem.Type === MESSAGE_TREE_TYPE_LINK_TO_MQA
    ) {
      if (temporaryArray.length) {
        const branches = {
          SortOrder: temporaryArray[0].SortOrder,
          Type: MESSAGE_TREE_TYPE_BRANCH,
          branches: [...temporaryArray]
        };
        filteredTree.push(branches);
        temporaryArray = [];
      }
      filteredTree.push(sortedTreeItem);
      return filteredTree;
    }

    temporaryArray.push(sortedTreeItem);
    if (temporaryArray.length && index === sortedTree.length - 1) {
      const branches = {
        SortOrder: temporaryArray[0].SortOrder,
        Type: MESSAGE_TREE_TYPE_BRANCH,
        branches: [...temporaryArray]
      };
      filteredTree.push(branches);
      temporaryArray = [];
      return filteredTree;
    }

    return filteredTree;
  });
  return filteredTree;
}
